import React, { useState, useEffect } from 'react';

export function LiveToasts({ notifications }) {
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    if (notifications.length === 0) return;
    const latest = notifications[0];
    if (!latest) return;

    setVisible(prev => {
      if (prev.some(v => v.id === latest.id)) return prev;
      return [latest, ...prev].slice(0, 3);
    });

    const timer = setTimeout(() => {
      setVisible(prev => prev.filter(v => v.id !== latest.id));
    }, 6000);

    return () => clearTimeout(timer);
  }, [notifications]);

  if (visible.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm" data-testid="live-toasts">
      {visible.map(n => (
        <div key={n.id}
          className={`bg-[#11141D] border px-4 py-3 shadow-2xl animate-in slide-in-from-right fade-in duration-300 ${
            n.severity === 'success' ? 'border-emerald-500/50' :
            n.severity === 'warning' ? 'border-amber-500/50' :
            'border-blue-500/50'
          }`}
          style={{ animation: 'slideInRight 0.3s ease-out' }}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full animate-pulse ${
                n.severity === 'success' ? 'bg-emerald-500' :
                n.severity === 'warning' ? 'bg-amber-500' :
                'bg-blue-500'
              }`} />
              <span className={`text-xs font-bold font-mono ${
                n.type === 'trade' ? 'text-blue-400' :
                n.type === 'milestone' ? 'text-emerald-400' :
                n.type === 'agent' ? 'text-amber-400' :
                'text-slate-300'
              }`}>{n.title}</span>
            </div>
            <button onClick={() => setVisible(prev => prev.filter(v => v.id !== n.id))}
              className="text-slate-600 hover:text-white text-xs">x</button>
          </div>
          <p className="text-xs text-slate-400 mt-1 pl-4">{n.message}</p>
        </div>
      ))}
    </div>
  );
}
